// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"166":"6d9110f9","207":"aff7a128","939":"81c344c6"}[chunkId] + ".chunk.css";
};